import { ShippingMethodCode } from '../../shared/enums/shipping-method-code';
import { Guid, Nillable } from '@web/utils';
import { ShipmentStatus } from '../../shared/enums/shipment-status';
import { PublicOrderShippingAddress } from './public-order-shipping-address';
import { OrderShipmentRefundSummary } from '../../shared/models';

export class PublicOrderShipment {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      status: ShipmentStatus;
      id: Guid;
      price: number;
      createdAt: Date;
      methodId: Guid;
      methodName: string;
      methodCode: ShippingMethodCode;
      address: PublicOrderShippingAddress;
      trackingUrl?: Nillable<string>;
      scheduledShippingDate?: Nillable<Date>;
      refundSummary?: Nillable<OrderShipmentRefundSummary>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }
  public get status(): ShipmentStatus {
    return this.data.status;
  }

  public get price(): number {
    return this.data.price;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get methodId(): Guid {
    return this.data.methodId;
  }

  public get methodName(): string {
    return this.data.methodName;
  }

  public get methodCode(): ShippingMethodCode {
    return this.data.methodCode;
  }

  public get address(): PublicOrderShippingAddress {
    return this.data.address;
  }

  public get trackingUrl(): Nillable<string> {
    return this.data.trackingUrl;
  }

  public get scheduledShippingDate(): Nillable<Date> {
    return this.data.scheduledShippingDate;
  }

  public get refundSummary(): Nillable<OrderShipmentRefundSummary> {
    return this.data.refundSummary;
  }
}
